import { Link, useParams } from 'react-router-dom';
import { useDiff, useVersiones } from '../api/hooks';
import { DiffVista } from '../components/DiffVista';
import { autor, fecha } from '../utils/formato';

const ACCION: Record<string, string> = { semilla: 'Semilla', crear: 'Alta', editar: 'Cambio', desactivar: 'Desactivación' };

export function VersionesPage() {
  const versiones = useVersiones();
  if (versiones.isLoading) return <p className="cargando">Cargando…</p>;
  if (versiones.error) return <div className="aviso aviso-error">{versiones.error.message}</div>;
  return (
    <>
      <h1>Versiones de la configuración</h1>
      <p className="subtitulo">Cada cambio crea una versión completa e inmutable. La de arriba es la vigente: la que lee Airflow.</p>
      <table className="tabla">
        <thead>
          <tr>
            <th>Versión</th>
            <th>Huella</th>
            <th>Fecha</th>
            <th>Qué</th>
            <th>Tabla</th>
            <th>Quién</th>
            <th>Motivo</th>
          </tr>
        </thead>
        <tbody>
          {versiones.data!.map((v, i) => (
            <tr key={v.id}>
              <td>
                <Link to={`/versiones/${v.id}`}>{v.id}</Link>
                {i === 0 && <span className="badge badge-ok">vigente</span>}
              </td>
              <td>
                <code>{v.version}</code>
              </td>
              <td>{fecha(v.created_at)}</td>
              <td>{ACCION[v.accion] ?? v.accion}</td>
              <td>{v.tabla ? <Link to={`/tablas/${v.tabla}`}>{v.tabla}</Link> : '—'}</td>
              <td>{autor(v.autor)}</td>
              <td>{v.motivo}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export function VersionPage() {
  const id = Number(useParams().id);
  const diff = useDiff(id);
  if (diff.isLoading) return <p className="cargando">Cargando…</p>;
  if (diff.error) return <div className="aviso aviso-error">{diff.error.message}</div>;
  const d = diff.data!;
  return (
    <>
      <p className="miga">
        <Link to="/versiones">Versiones</Link> / {d.id}
      </p>
      <h1>
        Versión {d.id} <code>{d.version}</code>
      </h1>
      <p className="subtitulo">
        {ACCION[d.accion] ?? d.accion}
        {d.tabla ? ` de ${d.tabla}` : ''} · {autor(d.autor)} · {fecha(d.created_at)}
        {d.anterior_id !== null && (
          <>
            {' '}
            · frente a la <Link to={`/versiones/${d.anterior_id}`}>{d.anterior_id}</Link>
          </>
        )}
      </p>
      <blockquote className="motivo">{d.motivo}</blockquote>
      <DiffVista cambios={d.cambios} resumirAltas={d.anterior_id === null} />
      <details className="yaml">
        <summary>Ver el YAML de esta versión</summary>
        <pre>{d.yaml_despues}</pre>
      </details>
    </>
  );
}
